import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ItemService from '../../../services/supplier_appCommonService';

// --- Async Thunks ---

export const fetchDraftCount = createAsyncThunk(
  'drafts/fetchCount',
  async ({ userId, draftType }) => {
    const response = await ItemService.getDraftCount(userId, draftType);
    return response.data.count; // Return just the number
  }
);

export const fetchDraftList = createAsyncThunk(
  'drafts/fetchList',
  async ({ userId, draftType }) => {
    const response = await ItemService.getDraftInitial(userId, draftType);
    return response.data; // Return the array of drafts
  }
);

export const deleteDraft = createAsyncThunk(
  'drafts/delete',
  async ({ documentNumber, userId, draftType }) => {
    await ItemService.deleteDraft(documentNumber, draftType, userId);
    return documentNumber; // Return the ID so we can remove it from the list
  }
);

export const renameDraft = createAsyncThunk(
  'drafts/rename',
  async ({ documentNumber, userId, draftType, newName }) => {
    await ItemService.renameDraft(documentNumber, userId, draftType, newName);
    return { documentNumber, newName }; // Return the updated data
  }
);

// --- Initial State ---
const initialState = {
  count: 0,
  list: [],
  loading: false,
};

// --- Slice ---
const draftsSlice = createSlice({
  name: 'drafts',
  initialState,
  reducers: {
    // Optional: reset state on logout
    resetDrafts: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      // Fetch Count
      .addCase(fetchDraftCount.fulfilled, (state, action) => {
        state.count = action.payload;
      })
      // Fetch List
      .addCase(fetchDraftList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDraftList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload || [];
      })
      .addCase(fetchDraftList.rejected, (state) => {
        state.loading = false;
        state.list = [];
      })
      // Delete Draft - UPDATES BOTH COUNT AND LIST
      .addCase(deleteDraft.fulfilled, (state, action) => {
        const deletedId = action.payload;
        // Remove from list
        state.list = state.list.filter(draft => draft.documentNumber !== deletedId);
        // Decrease the count
        state.count = state.count > 0 ? state.count - 1 : 0;
      })
      // Rename Draft - UPDATES THE LIST
      .addCase(renameDraft.fulfilled, (state, action) => {
        const { documentNumber, newName } = action.payload;
        const draft = state.list.find(d => d.documentNumber === documentNumber);
        if (draft) {
          draft.draftName = newName; // Directly mutate (immer handles it safely)
        }
        // Count does NOT change on rename, so we leave it.
      });
  },
});

export const { resetDrafts } = draftsSlice.actions;
export default draftsSlice.reducer;